//Signin Page
import React, { useEffect, useState } from "react";
import styles from "../../Styles/Signin/styles.module.css";
import bubbles from "../../images/bubble.png";
import bubbles2 from "../../images/Bubbles (1).svg";
import bubble from "../../images/Ellipse 13.png";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import hello from "../../images/Vector.svg";
import hii from "../../images/eye.svg";
import { useNavigate } from "react-router-dom";
import "../../Styles/Signin/signin.css";
import {
  authenticate,
  isAuthenticated,
  signin,
  verify,
  resendOtp,
} from "../../helper/authApiCalls/auth";
import jwtDecode from "jwt-decode";
import OTPInput from "otp-input-react";
const Signin = () => {
  const [values, setValues] = useState({
    email: "",
    password: "",
    showpassword: false,
    error: "",
    forgotEmail: "",
    didRedirect: isAuthenticated().status === "success" ? true : false,
    loading: false,
    succes: false,
  });
  const [error, setError] = useState("");
  const [error2, setError2] = useState("");

  var { email, password, didRedirect } = values;
  const [OTP, setOTP] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const onSubmit = (event) => {
    setError("");
    event.preventDefault();
    setValues({ ...values, loading: true, error: false });
    email = email.toLowerCase();
    signin({ email, password })
      .then((data) => {
        const user = jwtDecode(data.token);

        if (data.status === "fail" || user.isVerified === false) {
          if (user.isVerified === false) {
            setError("Your Account is not Verified");
          } else {
            setError(data.message);

            setValues({
              ...values,
              loading: true,
              error: data.error,
              succes: false,
            });
          }
        } else {
          authenticate(data, () => {
            setValues({
              ...values,
              didRedirect: true,
            });
          });
        }
      })
      .catch(() => setError("invalid inputs"));
  };

  let navigate = useNavigate();
  const performRedirect = () => {
    if (didRedirect) {
      return navigate("/");
    }
  };

  const onOtpSubmit = (e) => {
    e.preventDefault();
    email = email.toLocaleLowerCase();

    const sendBody = {
      email: email,
      otp: parseInt(OTP),
    };

    verify(sendBody).then((data) => {
      if (data.status === "fail") {
        setError2(data.message);
      } else {
        return navigate("/");
      }
    });
  };

  function sendOtp(e) {
    setSuccess(true);
    e.preventDefault();

    const sendBody = {
      email: values.email.toLocaleLowerCase(),
    };
    resendOtp(sendBody).then((data) => {
      if (data.status === "fail") {
        setError2(data.message);
      }
    });
  }

  const otpDesk = () => {
    return (
      <div>
        <div className={styles.mainlog}>
          <span>Sign In Using OTP</span>
        </div>
        <div className={styles.someshit}>
          <span>
            Enter the 6-digit OTP sent on your registered email address
          </span>
        </div>
        <div className={styles.in}>
          <div className={styles.someshit2}>
            <OTPInput
              value={OTP}
              onChange={setOTP}
              autoFocus
              className="heyHEllo"
              OTPLength={6}
              otpType="number"
              disabled={false}
            />
          </div>
        </div>
        {error2 && <div className={styles.error2}>*{error2}</div>}
        <div className={styles.resend}>
          <button onClick={sendOtp}>Resend OTP</button>
        </div>
        <div className={styles.button}>
          <button onClick={onOtpSubmit}>Verify Now</button>
        </div>
      </div>
    );
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showpassword: !values.showpassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    performRedirect();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [didRedirect]);

  const signinPage = () => {
    return (
      <div className="text">
        <div className={styles.signin}>
          <div className={styles.rightflank}>
            <div className={styles.fig}>
              <img src={bubbles} alt="%" />
            </div>

            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.downspans}>
              <div className={styles.upspan}>
                <span>Grow by learning</span>
                <img src={bubble} alt="" />
              </div>
              <div className={styles.downspan}>
                <span>
                  We strive to help and bring together the online learners
                  community by compiling knowledgeable resources from all over
                  the internet.
                </span>
              </div>
            </div>
          </div>
          <div className={styles.leftflank}>
            {!success ? (
              <div>
                <div className={styles.mainlog}>
                  <span>Log In</span>
                </div>
                <div className={styles.in}>
                  <div className={styles.in1}>
                    <TextField
                      sx={{
                        "& .MuiInputBase-input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px var(--bg-secondary) inset !important",
                          WebkitTextFillColor: "var(--text-primary) !important",
                        },
                      }}
                      label="Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      onChange={handleChange("email")}
                      value={email}
                    />
                  </div>
                  <div className={styles.in2}>
                    <TextField
                      sx={{
                        "& .MuiInputBase-input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px var(--bg-secondary) inset !important",
                          WebkitTextFillColor: "var(--text-primary) !important",
                        },
                      }}
                      label="Password"
                      type={values.showpassword ? "text" : "password"}
                      value={values.password}
                      onChange={handleChange("password")}
                      id="outlined-size-small"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showpassword && (
                                <img src={hii} alt="*" className="img" />
                              )}
                              {!values.showpassword && (
                                <img src={hello} alt="*" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  {error === "Your Account is not Verified" && (
                    <div className={styles.sendotpbutton}>
                      <button onClick={sendOtp}>
                        please verify now by a click
                      </button>
                    </div>
                  )}

                  <div className={styles.button}>
                    <button onClick={onSubmit}>Log In</button>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.info1}>
                      <span>Don't have an account? </span>
                      <a href="/signup">Sign up</a>
                    </div>
                    <div className={styles.info2}>
                      <a href="/forgotpassword">Forgot Password</a>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>{otpDesk()}</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const signinMobile = () => {
    return (
      <div className="text2">
        <div className={styles.signinMob}>
          <div className={styles.bubblecontain}>
            <img src={bubbles2} alt="%" />
          </div>

          <div className={styles.name}>
            <div className={styles.uppername}>
              <span>EduUdr</span>
            </div>
            <div className={styles.lowername}>
              <span>upgrading the community</span>
            </div>
          </div>
          <div className={styles.body}>
            {!success ? (
              <div className={styles.innerdivm}>
                <div className={styles.loginm}>
                  <span>Login</span>
                </div>
                <div className={styles.in}>
                  <div className={styles.in1}>
                    <TextField
                      sx={{
                        "& .MuiInputBase-input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px var(--bg-secondary) inset !important",
                          WebkitTextFillColor: "var(--text-primary) !important",
                        },
                      }}
                      label="Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      onChange={handleChange("email")}
                      value={email}
                    />
                  </div>
                  <div className={styles.in2}>
                    <TextField
                      sx={{
                        "& .MuiInputBase-input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px var(--bg-secondary) inset !important",
                          WebkitTextFillColor: "var(--text-primary) !important",
                        },
                      }}
                      label="Password"
                      type={values.showpassword ? "text" : "password"}
                      value={values.password}
                      onChange={handleChange("password")}
                      id="outlined-size-small"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showpassword && (
                                <img src={hii} alt="*" className="img" />
                              )}
                              {!values.showpassword && (
                                <img src={hello} alt="*" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  {error === "Your Account is not Verified" && (
                    <div className={styles.sendotpbutton}>
                      <button onClick={sendOtp}>
                        please verify now by a click
                      </button>
                    </div>
                  )}
                  <div className={styles.button}>
                    <button onClick={onSubmit}>Log In</button>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.info1}>
                      <span>Don't have an account? </span>
                      <a href="/signup">Sign up</a>
                    </div>
                    <div className={styles.info2}>
                      <a href="/forgotpassword">Forgot Password</a>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.innerdivm}>{otpDesk()}</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {signinPage()}
      {signinMobile()}

      {performRedirect()}
    </div>
  );
};

export default Signin;
